// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--1q6DC","card":"styles-module--card--2IF3Q"};